import { useState } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import TopNav from "../Components/Navbar/TopNav";
import SideNav from "../Components/Navbar/SideNav";
import { Outlet, Navigate } from "react-router-dom";
import PopUpReusable from "../Components/PopUp/PopUpReusable";
import { useRecoilValue } from "recoil";
import { activeWorkspaceState, authState } from "../Recoil/RecoilState";
import SubscriptionWarningCard from "../Components/Cards/SubscriptionWarningCard";
import { drawerWidth } from "../utils/StaticVariables";
import { isActiveUserState } from "../Recoil/RecoilState";
import TokenCheck from "../Components/Auth/TokenCheck";
import useWorkspaceContext from "../hooks/useWorkspaceContext";

const AppLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const authRecoil = useRecoilValue(authState);
  const isActiveUserRecoil = useRecoilValue(isActiveUserState);
  const activeWorkspace = useRecoilValue(activeWorkspaceState);
  useWorkspaceContext();

  if (!authRecoil?.token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Box sx={{ display: "flex", overflow: "hidden" }}>
      <TokenCheck />
      <SideNav
        openHandel={() => setMobileOpen(!mobileOpen)}
        mobileOpen={mobileOpen}
        drawerWidth={drawerWidth}
      />
      <Box
        component="main"
        sx={{ flexGrow: 1, minWidth: 0, p: 3, width: "100vw", position: "relative" }}
      >
        <TopNav openHandel={() => setMobileOpen(!mobileOpen)} />
        <Toolbar />
        {!isActiveUserRecoil && <SubscriptionWarningCard />}
        <Box sx={{ mt: 4 }}>
          {/* Keyed by workspace: switching workspace remounts the page so it refetches. */}
          <Outlet key={activeWorkspace?.workspace_id ?? "none"} />
        </Box>
        <PopUpReusable />
      </Box>
    </Box>
  );
};

export default AppLayout;
